let getSettings = () =>{
    return {
        api:"https://chatterz6.herokuapp.com" ,                                   //"https://loginp.herokuapp.com"5
        socket:"https://socketchat6.herokuapp.com"
    }
}


export default getSettings()